import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext();

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useAuth = () => {
	const context = useContext(AuthContext);
	if (!context) {
		throw new Error("useAuth must be used within AuthProvider");
	}
	return context;
};

export const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(null);
	const [token, setToken] = useState(localStorage.getItem("seaToken"));
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (token) {
			axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
			fetchUser();
		} else {
			setLoading(false);
		}
	}, [token]);

	const fetchUser = async () => {
		try {
			const response = await axios.get(`${API}/auth/me`);
			setUser(response.data);
		} catch (error) {
			console.error("Failed to fetch user:", error);
			console.log("User data:", error);
			logout();
		} finally {
			setLoading(false);
		}
	};

	const login = async (email, password) => {
		const response = await axios.post(`${API}/auth/login`, { email, password });
		const { access_token, user: userData } = response.data;
		setToken(access_token);
		setUser(userData);
		localStorage.setItem("seaToken", access_token);
		axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
		return userData;
	};

	const register = async (email, password, name, phone) => {
		const response = await axios.post(`${API}/auth/register`, {
			email,
			password,
			name,
			phone,
		});
		const { access_token, user: userData } = response.data;
		setToken(access_token);
		setUser(userData);
		localStorage.setItem("seaToken", access_token);
		axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
		return userData;
	};

	const logout = () => {
		setUser(null);
		setToken(null);
		localStorage.removeItem("seaToken");
		delete axios.defaults.headers.common["Authorization"];
	};

	return (
		<AuthContext.Provider value={{ user, loading, login, register, logout }}>
			{children}
		</AuthContext.Provider>
	);
};
